<template>
	<i class="fa fa-circle" 
		:class="{
			'has-transition':hasTransition,
			online: userIsOnline
		}"
		:title="title">
	</i>
</template>
<script type="text/javascript">
export default {
	name: "LastActiveIndicator",
	props: ["lastActiveUtc","userId"],
	data() {
		return {
			lastActiveUtcLocal: this.lastActiveUtc,
			hasTransition: true,
			userIsOnline: false,
			counterTimer: null,
			elapsedSecondsValue: 0,
		}
	},
	watch: {
		lastActiveUtc() {
			let vm = this

			this.lastActiveUtcLocal = this.lastActiveUtc
			this.turnGreen()
		}
	},
	computed: {
		title() {
			let displayValue = this.elapsedSecondsValue

			if (this.elapsedSeconds() && this.elapsedSeconds() > 60) {
				displayValue = Math.round(this.elapsedSecondsValue / 60)

				let unit = "minute"
				if (displayValue != 1)
					unit += "s"

				return "Active "+displayValue+" "+unit+" ago"
			}
			else if (this.elapsedSeconds() > 0) {
				return "Active less than a minute ago"
			}
			else {
				return ""
			}
		}
	},
	methods: {
		elapsedSeconds() {
			if (this.lastActiveUtcLocal)
				return this.moment().diff(this.moment.utc(this.lastActiveUtcLocal),'seconds')
			else 
				return null
		},
		turnGreen() {
			let vm = this

			if (this.elapsedSeconds() && this.elapsedSeconds() < 60) {
				this.userIsOnline = true
				this.hasTransition = false

				clearInterval(this.counterTimer)

				this.counterTimer = setInterval(() => {
					vm.userIsOnline = false
					vm.hasTransition = true

					vm.elapsedSecondsValue = this.elapsedSeconds()

				},5000)
			}
		}
	},
	created() {
		this.turnGreen()

		let vm = this

		this.$bus.$on("userActivityUpdate",(users) => {
			users.forEach(user => {
				if (user.id == vm.userId) {
					vm.lastActiveUtcLocal = user.last_active
					vm.turnGreen()
				}
			})
		})
	}
}
</script>

<style type="text/css" scoped>
	.fa-circle {
		color: #ea9b9b;
	}

	.fa-circle.has-transition {
		transition: color 300s;
	}

	.fa-circle.online {
		color: limegreen;
	}
</style>